// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OccasionsList_wrapper__086W3"};